import { Creator } from '../../../../gql/types'
import { ReapplyIntroVideo } from './ReapplyIntroVideo'
import { ReapplyPortfolio } from './ReapplyPortfolio'
import { ReapplyReview } from './ReapplyReview'

interface Props {
  creator: Creator
  step: 1 | 2 | 3
  setStep: (step: 1 | 2 | 3) => void
}

const Reapplying = ({ creator, step, setStep }: Props) => {
  return (
    <div className='sm:mx-auto sm:w-full sm:max-w-2xl'>
      {step === 1 && (
        <div className='space-y-6 sm:p-6'>
          <div className='sm:mx-auto'>
            <h2 className='mt-0 text-left text-3xl font-extrabold text-gray-900'>
              We are unable to approve your application at this time
            </h2>
            <p className='mt-4 text-left text-sm text-gray-600'>
              Thank you for applying to join Clip, where we connect talented
              video creators with brands.
            </p>
            <p className='mt-4 text-left text-sm text-gray-600'>
              After a thorough review of your application, we regret to inform
              you that we cannot approve your account at this time. The
              introduction video or other details provided in your submission do
              not adhere to our guidelines.
            </p>
            <p className='mt-4 text-left text-sm text-gray-600'>
              We understand that this may be disappointing, but we encourage you
              to reapply with an updated introduction video and/or corrected
              account details that meet our platform's requirements.
            </p>
            <p className='mt-4 text-left text-sm text-gray-600'>
              We appreciate your interest in Clip and look forward to the
              opportunity to review your updated application.
            </p>
          </div>
        </div>
      )}

      <div style={{ display: step === 1 ? 'block' : 'none' }}>
        <ReapplyIntroVideo creator={creator} onContinue={() => setStep(2)} />
      </div>

      <div style={{ display: step === 2 ? 'block' : 'none' }}>
        <ReapplyPortfolio
          creator={creator}
          onContinue={() => setStep(3)}
          onBack={() => setStep(1)}
        />
      </div>

      <div style={{ display: step === 3 ? 'block' : 'none' }}>
        <ReapplyReview creator={creator} onBack={() => setStep(2)} />
      </div>
    </div>
  )
}

export { Reapplying }
